import localforage from 'localforage'
import axios from 'axios'
export const deliveriesPlanning = {
    state: {
        deliveries: null,
        loadingStatus: 'notLoading',
        deliveryDate: new Date().toISOString().slice(0,10),
    },
    mutations: {
        SET_DELIVERIESPLANING_LOADING_STATUS(state, status){
            state.loadingStatus = status
        },
        SET_DELIVERIESPLANING(state, content) {
            state.deliveries = content
        },
        SET_DELIVERIESPLANING_DATE(state, content) {
            state.deliveryDate = content
        }
    },
    actions: {
        fetchDeliveriesPlaning({ state, commit }) {
            // prevent multiple requests at same time
            if(state.loadingStatus === 'loading')
                return
            commit('SET_DELIVERIESPLANING_LOADING_STATUS', 'loading')
            return localforage.getItem('authUser').then((headers) => {
                return axios.get( process.env.VUE_APP_API+'deliveries/'+state.deliveryDate, {headers: JSON.parse(headers) })
                .then((response) => {
                    commit('SET_DELIVERIESPLANING', Object.freeze(response.data.data))
                    commit('SET_DELIVERIESPLANING_LOADING_STATUS', 'notLoading')
                    localforage.setItem('deliveries', response.data.data);
                })
                .catch(() => {
                    // load from local storage
                    console.log('Reading from local storage');
                    localforage.getItem('deliveries').then(deliveries => {
                        commit('SET_DELIVERIESPLANING', Object.freeze(deliveries))
                        commit('SET_DELIVERIESPLANING_LOADING_STATUS', 'notLoading')
                    })
                })
            })
        },
        setDeliveryDate({ commit, dispatch }, payload) {
            commit('SET_DELIVERIESPLANING_DATE', payload.deliveryDate)
            dispatch('fetchDeliveriesPlaning')
        },
    },
    getters: {
        getPlaned: (state) => {
            if(state.deliveries){
                return state.deliveries
            }
        },
        getTotalPlaned: (state) => {
            if(state.deliveries){
                return state.deliveries.length
            }
        },
        getDeliveryDate: (state) => {
            return state.deliveryDate
        },

    }
}
